export const locale: any = {
    en: "English",
    fr: "Français",
};